import { FormikState } from "formik";
import React from "react";

export const inputValidateAlphanumeric = (
  e: React.KeyboardEvent<HTMLInputElement>,
) => {
  const re = /[0-9a-zA-Z]+/g;
  if (!re.test(e.key)) {
    e.preventDefault();
  }
};
export const inputValidateAlphanumericPaste = (
  e: React.ClipboardEvent<HTMLInputElement>,
) => {
  const pastedText = e.clipboardData.getData("Text");
  if (!pastedText) {
    e.preventDefault();
    return;
  }
  const re = /[0-9a-zA-Z]+/g;
  // eslint-disable-next-line no-constant-condition
  if (!re.test(pastedText)) {
    e.preventDefault();
  }
};

export const getValueTooltip = <T>(
  title: string | undefined,
  bag: FormikState<T> | undefined,
  bagField: keyof T | undefined,
): string | undefined => {
  if (title) return title;

  if (!bag?.values || !bagField) return undefined;

  const bagValue = ((bag.values as any)[bagField] ?? "").toString();

  return bagValue;
};

export const parseIntOrDefault = (inputValue: any, defaultValue = 0) => {
  const valueParsed = parseInt(inputValue);

  if (isNaN(valueParsed)) return defaultValue;

  return valueParsed;
};
export const parseFloatOrDefault = (inputValue: any, defaultValue = 0) => {
  const valueParsed = parseFloat(inputValue);

  if (isNaN(valueParsed)) return defaultValue;

  return valueParsed;
};
